export { default as withInsights, inferPayload as inferInsightsPayload } from './client';
export { default as withInsightsListener } from './listener';


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/insights/index.js
// module id = null
// module chunks = 